// extracted by mini-css-extract-plugin
module.exports = {"cancelButton":"UpdateCustomerSubscriptionNote_cancelButton__3ZdaZ"};